// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","link":"outside-link_link__33_1s"};